import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { DefaultLocale, NotificationTypes } from '@shared/constants/constants';
import { NotificationType } from '@shared/enums/NotificationType';
import { INotification } from '@shared/services/api/dashboard/notifications-service/notifications-model';
import { IAppState } from '@state/reducers/app/app.reducer';
import { IState } from '@state/state.module';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

    public loadingIndicator = false;

    public NotificationType = NotificationType;
    public itemsNotificationTypes = NotificationTypes(this.translation);

    public locale = DefaultLocale;

    private state$: Observable<IAppState>;
    private destroy$ = new ReplaySubject<boolean>();

    @Input()
    get notifications(): INotification[] { return this.notifications$.value; }
    set notifications(value: INotification[]) { this.notifications$.next(value); }
    public notifications$: BehaviorSubject<INotification[]> = new BehaviorSubject<INotification[]>([]);

    constructor(
        private translation: TranslateService,
        private store: Store<IState>
    ) {}

    public ngOnInit() {
        this.state$ = this.store.select(x => x.app);
        this.state$.pipe(
            takeUntil(this.destroy$),
            tap(x => {
                // Set locale
                this.locale = x.profile.localeId;
            }))
            .subscribe();
    }
}
